import type { Revendeur } from "../data/products";

type RevendeurCtaProps = {
  revendeurs: Revendeur[];
};

export default function RevendeurCta({ revendeurs }: RevendeurCtaProps) {
  return (
    <>
      {revendeurs.map((revendeur: Revendeur) => {
        const { name, url, prix } = revendeur;
        return (
          <a
            href={url}
            target="_blank"
            rel="noreferrer noopener"
            key={name}
            className="btn"
          >
            Acheter chez {name} pour{" "}
            <span style={{ fontWeight: "bolder" }}>{prix}€</span>
          </a>
        );
      })}
    </>
  );
}
